module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.ddc05a8.eot";